import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateTimeHelper } from 'src/app/shared/helpers/datetime.helper';
import { PrescriptionHelper } from 'src/app/shared/helpers/prescription.helper';
import { untilComponentDestroyed } from 'src/app/shared/helpers/rxjs.operator';

@Component({
  selector: 'diana-delivery-on-stock-details',
  templateUrl: './delivery-on-stock-details.component.html',
  styleUrls: ['./delivery-on-stock-details.component.scss'],
  standalone: false
})
export class DeliveryOnStockDetailsComponent implements OnInit, OnChanges {
  @Input() deliveryOnStockDosageFormGroup!: FormGroup;
  @Input() idHtmlElements: string = '';
  @Input() visitAt!: Date;
  @Output() totalDeliveryChanged = new EventEmitter<number>();
  @Output() endDateChanged = new EventEmitter<Date>();

  get treatingAnimalsNumberControl(): FormControl {
    return this.deliveryOnStockDosageFormGroup.get('treatingAnimalsNumber') as FormControl;
  }
  get treatmentDaysControl(): FormControl {
    return this.deliveryOnStockDosageFormGroup.get('treatmentDays') as FormControl;
  }
  get animalDosisControl(): FormControl {
    return this.deliveryOnStockDosageFormGroup.get('animalDosis') as FormControl;
  }

  constructor() {
  }

  ngOnInit(): void {
    this.treatingAnimalsNumberControl.valueChanges
      .pipe(untilComponentDestroyed(this))
      .subscribe((treatingAnimalsNumber) => {
        this.setTotalDeliveryQuantity(treatingAnimalsNumber, this.treatmentDaysControl.value, this.animalDosisControl.value);
      });
    this.treatmentDaysControl.valueChanges
      .pipe(untilComponentDestroyed(this))
      .subscribe((treatmentDays) => {
        this.setTotalDeliveryQuantity(this.treatingAnimalsNumberControl.value, treatmentDays, this.animalDosisControl.value);
        this.updateVisistAt();
      });
    this.animalDosisControl.valueChanges
      .pipe(untilComponentDestroyed(this))
      .subscribe((animalDosis) => {
        this.setTotalDeliveryQuantity(this.treatingAnimalsNumberControl.value, this.treatmentDaysControl.value, animalDosis);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visitAt'] && !changes['visitAt'].firstChange) {
      this.updateVisistAt();
    }
  }

  private setTotalDeliveryQuantity(treatingAnimalsNumber: string, treatmentDays: string, animalDosis: string): void {
    let totalDeliveryQuantity = PrescriptionHelper.calcTotalDeliveryQuantity(treatingAnimalsNumber, treatmentDays, animalDosis);
    this.totalDeliveryChanged.emit(totalDeliveryQuantity);
  }

  /**
 * Setting and calculating the durationInDays based on the values in the dosage form
 */
  updateVisistAt(): void {
    if (this.visitAt) {
      let totalDurationDays = this.treatmentDaysControl.value;
      totalDurationDays = totalDurationDays - 1;
      let newEndDate = DateTimeHelper.copyDate(this.visitAt);
      if ((totalDurationDays) > 0) {
        newEndDate = DateTimeHelper.copyDate(newEndDate.setDate(newEndDate.getDate() + totalDurationDays));
      }
      this.endDateChanged.emit(newEndDate);
    }

  }
}
